module.exports = __webpack_public_path__ + "img/img (8).eb2cfa2e.jpg";